<script setup>
    /**
     * Vue Scripts
     */
    import {sendToPage} from "@util/api";
    import {searchStore} from "@pinia/search-store";

    /**
     * Vue Components
     */
    import PredictiveDropdown from "@component/PredictiveDropdown/PredictiveDropdown.vue";
    import SearchButton from "@component/SearchButton/SearchButton.vue";
    import {computed, ref} from "vue";

    /**
     * Static Variables
     */
    const {predictiveApi,} = API;
    const {menuSearchText} = NAV || '';
    const {isHcps} = GLOBAL;
    const {title, a11yTitle, placeholder} = TRIALS?.filterBar;

    const noResults = GLOBAL?.dropdownNoResults || '';
    const searchId = 'trials-search-module-input'

    /**
     * Dynamic Variables
     */
    const store = searchStore();
    const query = computed(() => store.query)
    const searchedItem = ref({})

    const setResult = ({name, url}) => {
        if (url) sendToPage(url)

        store.$patch({
            query: {
                ...store.query,
                ...store.coords,
                page: 1,
                search: name,
            },
            searchedText: name,
        })

        store.searchApi(store.query)
    }

    const searchResult = (data) => {
        store.searchApi(store.query)
    }

</script>

<template>
    <div class="search-box">
        <div class="box teal">
            <h2
                v-if="title"
                v-html="title"
            />

            <form
                action=""
                id="trial-search-module"
                class="predictive-search-form"
            >
                <div class="form-header screen-reader-only">
                    <label
                        :for="searchId"
                        v-html="a11yTitle"
                    />
                </div>

                <div class="form-body">
                    <PredictiveDropdown
                        :id="`${searchId}-container`"
                        :input-id="searchId"
                        :api="predictiveApi"
                        :placeholder="placeholder"
                        :noResults="noResults"

                        name="s"

                        closeOnSelect
                        load-from-query

                        @getResult="setResult"
                    />

                    <SearchButton
                        :button-text="menuSearchText"
                        @clickAction="searchResult(searchedItem)"
                    />

                </div>

            </form>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Search Box"
    }
</script>

<style lang="scss" scoped>

</style>
